// extracted by mini-css-extract-plugin
export default {"appLoader":"AppLoader_appLoader__o-u2K"};